// import firebase from "@firebase/app";
import $models from '@/models'
import util from '@/util'
import moment from '@/moment-gp.js';

const $timeslotCollection = $models.timeslotCollection;
// "/user/{uid}/timeslot_collections/*"

const $timeslotWeekdayPref = $models.timeslotWeekdayPref;
// "/user/{uid}/timeslot_collections/{timeslotCollectionId}/weekday_preferences/*"

const $timeslotException = $models.timeslotException;
// "/user/{uid}/timeslot_collections/{timeslotCollectionId}/exception_list/*"

/* =========================== Helper functions ============================= */

function get_last_sortidx_for_timeslot_collection() {

  let timeslot_collection_list = $timeslotCollection.getList();
  let array = timeslot_collection_list.itemsAsArray();

  if ( array.length > 0 ) {
    let last_sort_idx = array.reduce((p, v) => ( p.sortidx  > v.sortidx  ? p : v ) )
    return last_sort_idx.sortidx + 1;
  } else {
    return 1;
  }
}

// -----------------------------------------------------------------------------
export function timeslot_collection_add_to_user({ tscType = 'TSC' } = {}, data = {}) {

  // Timeslots should be stored "timezone neutral" as UTC => nothing to do here
  // since collections and rules don't have a timezone

  // Create emtpy timeslot collection
  const timeslot_collection = $timeslotCollection.new_from_template({ type: tscType }, data);

  // timeslot_collection.sortidx = ?
  if ( tscType === 'TSC' ) {
  } else if ( tscType === 'BLOCKER' ) {
    // TODO: This should be done while user is created
  } else if ( tscType === 'GOOGLE' ) {
    // TODO
  } else if ( tscType === 'COMMITMENT' ) {
    // TODO
  } else {
    throw new Error('TSC-Type not supported:' + tscType)
  }

  // Set sortidx to last value
  timeslot_collection.sortidx = data.sortidx || get_last_sortidx_for_timeslot_collection()

  // Add timeslot collection to user timeslot collection
  return timeslot_collection.write();
}

// -----------------------------------------------------------------------------

export function timeslot_collection_create_from_array( tscList ) {

  let promiseList = [];

  tscList.forEach(( tsc, index ) => {

    let data = {
      sortidx: index + 1,
      name:    tsc.name,
      color:   tsc.color,
    }

    let promise = timeslot_collection_add_to_user({ tscType: 'TSC' }, data);
    promise.then(timeslotCollectionId => {
      console.log("Got timeslotCollectionId", timeslotCollectionId)

      let promiseListRules = tsc.rules.map(rule => {
        return timeslot_collection_add_rule({
          timeslotCollectionId,
          rule: {
            selectedWeekdays: rule.weekdays,
            from: rule.from,
            to: rule.to,
          }
        })
      })
      promiseList.push( ...promiseListRules )
    })
    promiseList.push( promise )
  })

  return Promise.all(promiseList)
}

// -----------------------------------------------------------------------------
export function timeslot_collection_set({ timeslotCollectionId, prop, value }) {

  if ( !util.isValidId( timeslotCollectionId ) ) {
    throw new Error('Invalid timeslotCollectionId', timeslotCollectionId)
  }

  if ( !prop || value === undefined ) {
    throw new Error('Invalid prop or value for ' + prop)
  }

  return $timeslotCollection.update(timeslotCollectionId, { [prop]: value });
}

// -----------------------------------------------------------------------------
export function timeslot_collection_set_priorities({ priorities }) {

  /* let payload = {};
  priorities.forEach(({ id, sortidx }) => {
    payload[`timeslotCollectionList.${id}.sortidx`] = sortidx;
  }); */

  return $timeslotCollection.reorder( priorities )
}

// -----------------------------------------------------------------------------
export function timeslot_collection_set_color({ timeslotCollectionId, color }) {
  return timeslot_collection_set({ timeslotCollectionId, prop: 'color', value: color })
}

// -----------------------------------------------------------------------------
export function timeslot_collection_set_name({ timeslotCollectionId, name }) {
  return timeslot_collection_set({ timeslotCollectionId, prop: 'name', value: name })
}

// -----------------------------------------------------------------------------
export function timeslot_collection_set_prioritized_effort_type({ timeslotCollectionId, prioritizedEffortType }) {

  if ( !util.isValidId( timeslotCollectionId ) ) {
    throw new Error('Invalid timeslotCollectionId', timeslotCollectionId)
  }

  const VALID_EFFORT_TYPES = [
    'COMMITMENT_TEMPLATE',
    'COMMITMENT',
    'SEQUENCE_TYPE1',
    'SEQUENCE_TYPE2',
    'FIXED_TSC'
  ];

  if ( VALID_EFFORT_TYPES.includes(prioritizedEffortType) ) {
    return timeslot_collection_set({ timeslotCollectionId, prop: 'prioritizedEffortType', value: prioritizedEffortType })
  } else {
    console.warn('Invalid effort type', prioritizedEffortType);
  }
}

// -----------------------------------------------------------------------------
export function timeslot_collection_add_rule({ timeslotCollectionId, rule }) {
  /* rule = weekday_preference */

  // Timeslots should be stored "timezone neutral" as UTC
  //  => nothing to do here since rules don't have a timezone

  if ( !util.isValidId( timeslotCollectionId ) ) {
    throw new Error('Invalid timeslotCollectionId', timeslotCollectionId)
  }

  return $timeslotWeekdayPref.add( { timeslotCollectionId, ...rule } )
  // return $timeslotWeekdayPref.with({ timeslotCollectionId }).add( rule )
}

// -----------------------------------------------------------------------------
export function timeslot_collection_update_rule({ timeslotCollectionId, ruleId, newRule }) {

  if ( !util.isValidId( timeslotCollectionId ) ) {
    throw new Error('Invalid timeslotCollectionId', timeslotCollectionId)
  }

  if ( !util.isValidId( ruleId ) ) {
    throw new Error('Invalid ruleId', ruleId)
  }

  // Timeslots should be stored "timezone neutral" as UTC => nothing to do here
  // since rules don't have a timezone

  /*
  if ( 'valid_after' in newRule ) {
    newRule.valid_after = firebase.firestore.Timestamp.fromDate( new Date(newRule.valid_after) );
  }
  if ( 'valid_before' in newRule ) {
    newRule.valid_before = firebase.firestore.Timestamp.fromDate( new Date(newRule.valid_before) );
  }
  */

  // return $timeslotWeekdayPref.with({ timeslotCollectionId }).update( ruleId, newRule )
  return $timeslotWeekdayPref.update( ruleId, newRule )
}

// -----------------------------------------------------------------------------
export function timeslot_collection_rem_rule({ timeslotCollectionId, ruleId }) {

  if ( !util.isValidId( timeslotCollectionId ) ) {
    throw new Error('Invalid timeslotCollectionId', timeslotCollectionId)
  }

  if ( !util.isValidId( ruleId ) ) {
    throw new Error('Invalid ruleId', ruleId)
  }

  // Soft delete?

  // return $timeslotWeekdayPref.with({ timeslotCollectionId }).remove( ruleId )
  return $timeslotWeekdayPref.remove( ruleId )
}

// -----------------------------------------------------------------------------
export function timeslot_collection_set_rule_priorities({ timeslotCollectionId, priorities }) {

  if ( !util.isValidId( timeslotCollectionId ) ) {
    throw new Error('Invalid timeslotCollectionId', timeslotCollectionId)
  }

  /* let payload = {};
  priorities.forEach(({ id, sortidx }) => {
    payload[`timeslotCollectionList.${timeslotCollectionId}.weekday_preferences.${id}.sortidx`] = sortidx;
  }); */

  // return $timeslotWeekdayPref.with({ timeslotCollectionId }).reorder( priorities )
  return $timeslotWeekdayPref.reorder( priorities ) // TODO - testen
}

// -----------------------------------------------------------------------------
export function timeslot_collection_add_exception({ timeslotCollectionId, exception, override_timezone = false }) {

  if ( !util.isValidId( timeslotCollectionId ) ) {
    throw new Error('Invalid timeslotCollectionId', timeslotCollectionId)
  }

  // TODO: It would be better to store timeslots "timezone neutral" as UTC
  //       ==> something to do here

  let timeslot_collection = $timeslotCollection.getNode( timeslotCollectionId )
  /*
  let timeslot_collection_list = getters.timeslot_collection_list;
  let timeslot_collection = timeslot_collection_list.find((tsc) => tsc.$id === timeslotCollectionId);
  */
  if ( !timeslot_collection ) {
    throw new Error(`Timeslot collection with ID ${timeslotCollectionId} not found or not ready`);
  }
  let tscType = timeslot_collection.type || 'TSC'; // Default -> TSC

  let exceptionTemplate = $timeslotException
    // .with({ timeslotCollectionId })
    .new_from_template({
      timeslotCollectionId,
      tscType,
      exceptionType: exception.type });

  if ( !exceptionTemplate.$state ) {
    throw new Error(`Combination <${tscType}> and <${exception.type}>" not allowed`);
  }

  // let exceptionValidated = {};
  Object.keys(exceptionTemplate.$state).map((key) => {
    exceptionTemplate[key] = exception[key] || exceptionTemplate[key];
  })

  if ( override_timezone ) {
    console.log('Converting timezone to', override_timezone);
    exceptionTemplate.from = moment.fromTimezoneNeutral( exceptionTemplate.from )
                                  .changeTimezoneButKeepTime( override_timezone );

      // convert_timezoneNeutral_to_qualifiedMomentObj(
        // moment( exceptionTemplate.from ), timezone );

    exceptionTemplate.to = moment.fromTimezoneNeutral( exceptionTemplate.to )
                                  .changeTimezoneButKeepTime( override_timezone );

      // convert_timezoneNeutral_to_qualifiedMomentObj(
        // moment( exceptionTemplate.to ), timezone );
  } else {
    // TODO: Convert to UTC here
    /*

    exceptionTemplate.from = new Date( exceptionTemplate.from );
    exceptionTemplate.to = new Date( exceptionTemplate.to );

    */

    // ONLY MOMENT OBJECTS GET CONVERTED

    exceptionTemplate.from = moment( exceptionTemplate.from );
    exceptionTemplate.to = moment( exceptionTemplate.to );
  }

  // TESTEN lib should take care
  /*
  if ( 'date' in exceptionValidated ) {
    exceptionValidated.date = firebase.firestore.Timestamp.fromDate( new Date(exceptionValidated.date) );
  }
  if ( 'from' in exceptionValidated ) {
    exceptionValidated.from = firebase.firestore.Timestamp.fromDate( exceptionValidated.from );
  }
  if ( 'to' in exceptionValidated ) {
    exceptionValidated.to = firebase.firestore.Timestamp.fromDate( exceptionValidated.to );
  }*/

  return exceptionTemplate.write();
}

// -----------------------------------------------------------------------------
export function timeslot_collection_rem_exception({ timeslotCollectionId, exceptionId }) {

  if ( !util.isValidId( timeslotCollectionId ) ) {
    throw new Error('Invalid timeslotCollectionId', timeslotCollectionId)
  }

  if ( !util.isValidId( exceptionId ) ) {
    throw new Error('Invalid exceptionId', exceptionId)
  }

  // return $timeslotException.with({ timeslotCollectionId }).remove( exceptionId )
  return $timeslotException.remove( exceptionId )
}

// -----------------------------------------------------------------------------
export function timeslot_collection_update_exception({ timeslotCollectionId, exceptionId, newException }) {

  if ( !util.isValidId( timeslotCollectionId ) ) {
    throw new Error('Invalid timeslotCollectionId', timeslotCollectionId)
  }

  if ( !util.isValidId( exceptionId ) ) {
    throw new Error('Invalid exceptionId', exceptionId)
  }

  // TODO: It would be better to store timeslots "timezone neutral" as UTC
  //       ==> something to do here

  // TESTEN lib should take care
  // TODO: see timeslot_collection_add_exception
  /*
  if ( 'date' in newException ) {
    newException.date = firebase.firestore.Timestamp.fromDate( new Date(newException.date) );
  }
  if ( 'from' in newException ) {
    newException.from = firebase.firestore.Timestamp.fromDate( new Date(newException.from) );
  }
  if ( 'to' in newException ) {
    newException.to = firebase.firestore.Timestamp.fromDate( new Date(newException.to) );
  }
  */

  return $timeslotException.update( exceptionId, newException )
  // return $timeslotException.with({ timeslotCollectionId }).update( exceptionId, newException )
}

// -----------------------------------------------------------------------------
export function timeslot_collection_delete({ timeslotCollectionId, delete_mode }) {

  // TODO: This does not scale, when there is a lot of exceptions
  // TODO: Do not allow to delete blocker -> security rule ?

  /* Delete timeslots rules and exceptions */
  if ( delete_mode === "hard" ) {
    let exception_list_all = $models.timeslotException.getList().itemsSorted
    let exception_list = exception_list_all.filter(exception => exception.tscId === timeslotCollectionId )

    exception_list.forEach(exception => {
      timeslot_collection_rem_exception({ timeslotCollectionId, exceptionId: exception.$id })
    })

    let rule_list_all = $models.timeslotWeekdayPref.getList().itemsSorted
    let rule_list = rule_list_all.filter(exception => exception.tscId === timeslotCollectionId )

    rule_list.forEach(rule => {
      timeslot_collection_rem_rule({ timeslotCollectionId, ruleId: rule.$id })
    })
  }

  if ( !util.isValidId( timeslotCollectionId ) ) {
    throw new Error('Invalid timeslotCollectionId', timeslotCollectionId)
  }

  return $timeslotCollection.remove( timeslotCollectionId, delete_mode === "soft" )
}
